// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9mpvu","type":"styles_type__1aJnx","choices":"styles_choices__3jroG"};